export default {"src":"/polygon/_next/static/media/fund_6.1d0c5f99.svg","height":80,"width":231};